"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormReadonlyField = void 0;
const form_field_1 = require("./form-field");
const readonly_field_1 = require("../../../components/readonly-field/readonly-field");
exports.FormReadonlyField = form_field_1.formFieldFactory(readonly_field_1.ReadonlyField);
//# sourceMappingURL=form-readonly-field.js.map